import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import en from './locales/en.json';
import zh from './locales/zh.json';
import ja from './locales/ja.json';

export type Language = 'en' | 'zh' | 'ja';

export type TranslationKeys = typeof en;

const translations: Record<Language, TranslationKeys> = {
  en,
  zh,
  ja,
};

interface I18nStore {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string, params?: Record<string, string | number>) => string;
}

export const useI18n = create<I18nStore>()(
  persist(
    (set, get) => ({
      language: 'en',
      setLanguage: (lang: Language) => set({ language: lang }),
      t: (key: string, params?: Record<string, string | number>) => {
        const { language } = get();
        const keys = key.split('.');
        let value: any = translations[language];

        for (const k of keys) {
          if (value && typeof value === 'object') {
            value = value[k];
          } else {
            return key; // Return key if translation not found
          }
        }

        if (typeof value !== 'string') {
          return key;
        }

        // Replace parameters in the translation
        if (params) {
          return Object.entries(params).reduce((str, [paramKey, paramValue]) => {
            return str.replace(new RegExp(`\\{${paramKey}\\}`, 'g'), String(paramValue));
          }, value);
        }

        return value;
      },
    }),
    {
      name: 'feedflow-i18n',
      partialize: (state) => ({ language: state.language }),
    }
  )
);

export const LANGUAGES = [
  { code: 'zh' as const, label: '中文', flag: '🇨🇳' },
  { code: 'en' as const, label: 'English', flag: '🇺🇸' },
  { code: 'ja' as const, label: '日本語', flag: '🇯🇵' },
];
